import React, { Component, PropTypes } from 'react';

import ListContainer from './components/ListContainer';

class ListsView extends Component {
  static propTypes = {
    isEditing: PropTypes.bool // Can't make isRequired because prop is added in React.cloneElement() in App.js
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  handleSelect = key => {
    this.context.router.push(`/items/${key}`);
  }

  render() {
    return (
      <ListContainer root="/lists" isEditing={this.props.isEditing} onSelect={this.handleSelect} confirmRemove />
    );
  }
}

export default ListsView;



/** WEBPACK FOOTER **
 ** ./src/ListsView.js
 **/